"use client";

import { Heading } from "@pamperedchef/design-system";

import { ChipLink } from "@/composites/foundation";

import * as styles from "./CategoryChips.module.scss";

export interface CategoryChip {
	label: string;
	href: string;
}

export interface CategoryChipsProps {
	heading?: string;
	links: CategoryChip[];
}

export function CategoryChips({
	heading,
	links
}: CategoryChipsProps): JSX.Element | null {
	if (links.length === 0) return null;

	return (
		<section className={styles["chips"]} data-component="CategoryChips">
			{heading ? (
				<Heading tag="h2" className={styles["chips__heading"]}>
					{heading}
				</Heading>
			) : null}
			<ul className={styles["chips__list"]}>
				{links.map((link) => (
					<li key={link.href}>
						<ChipLink href={link.href}>{link.label}</ChipLink>
					</li>
				))}
			</ul>
		</section>
	);
}
